import { fallback } from '@tanstack/zod-adapter';
import { resolveTrackingParams } from 'router/utils';
import { z } from 'zod';

const trackingSearchParams = fallback(
  z
    .union([
      z.number().nullish(),
      z.string().nullish(),
      z.array(z.union([z.string(), z.number()])),
    ])
    .optional()
    .transform(resolveTrackingParams),
  undefined,
);

export const signupSearchParams = z.object({
  utm_term: trackingSearchParams,
  utm_campaign: trackingSearchParams,
  utm_content: trackingSearchParams,
  utm_medium: trackingSearchParams,
  utm_source: trackingSearchParams,
  source: trackingSearchParams,
  ssu_coupon: fallback(z.coerce.string().optional(), undefined),
});

export type SignupSearchParams = z.infer<typeof signupSearchParams>;
